var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('congrats-modal'),_c('userHeader'),_c('clarity'),_vm._t("default"),_c('sidebar'),_c('chat-box')],2)}
var staticRenderFns = []

export { render, staticRenderFns }